module.exports = __webpack_public_path__ + "static/media/suji_rava.95bb952d.png";